import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiConfig } from 'src/app/core/_constants/api.config';

@Injectable()
export class ApiService {
  constructor(private http: HttpClient) { } // CONSTRUCTOR

  private defaultHeaders = new HttpHeaders({
    'X-Frame-Options': 'SAMEORIGIN',
    'X-Content-Type-Options': 'nosniff',
    'Strict-Transport-Security': 'max-age=31536000',
    'Content-Security-Policy': 'default-src \'self\'',
    'Referrer-Policy': 'same-origin',
    'Permissions-Policy': 'geolocation=(self)',
    'Cross-Origin-Embedder-Policy': 'require-corp',
    'Cross-Origin-Resource-Policy': 'same-origin',
    'Cross-Origin-Opener-Policy': 'same-origin'
  });

  public get(urlPath: string, customHeaders?: HttpHeaders) {
    urlPath = ApiConfig.API_ENDPOINT + urlPath;
    const headers = customHeaders || this.defaultHeaders;
    return this.http.get<any[]>(urlPath, { headers });
  }

  public post(urlPath: string, data: any, customHeaders?: HttpHeaders) {
    urlPath = ApiConfig.API_ENDPOINT + urlPath;
    const headers = customHeaders || this.defaultHeaders;
    return this.http.post(urlPath, data, { headers });
  }

  public patch(urlPath: string, data: any, customHeaders?: HttpHeaders) {
    urlPath = ApiConfig.API_ENDPOINT + urlPath;
    const headers = customHeaders || this.defaultHeaders;
    return this.http.patch(urlPath, data, { headers });
  }

  public put(urlPath: string, data: any, customHeaders?: HttpHeaders) {
    urlPath = ApiConfig.API_ENDPOINT + urlPath;
    const headers = customHeaders || this.defaultHeaders;
    return this.http.put(urlPath, data, { headers });
  }

  public delete(urlPath: string, customHeaders?: HttpHeaders) {
    urlPath = ApiConfig.API_ENDPOINT + urlPath;
    const headers = customHeaders || this.defaultHeaders;
    return this.http.delete(urlPath, { headers });
  }
} // EXPORT
